import axios from "axios";
import { firebaseAuth } from "../../firebase/app";
import store from "../../redux/store";

const createApiClient = async () => {
  // const state = store.getState();
  // const userRole = state.user.role;
  const role = store.getState().auth.role;
  const uid = store.getState().auth.uid;
  const user = firebaseAuth.currentUser;
  // const adminUid = store.getState().auth.adminUid;
  // const auth = store.getState().auth;
  if (!user) {
    throw new Error("User not authenticated");
  }

  const token = await user.getIdToken();

  const path = `${import.meta.env.VITE_BASE_URL}`;
  const params = role === "admin" || role === "staff" ? { user: uid } : {};

  const apiClient = axios.create({
    baseURL: path,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    params: params,
  });

  return apiClient;
};

export default createApiClient;
